import React from "react";
import { Form, Input } from "antd";

export function InputText(props) {
  const inputReference = React.useRef(null);

  React.useEffect(() => {
    if (props.isAutoFocus) {
      inputReference.current.focus();
    }
    // eslint-disable-next-line
  }, []);

  const onFocus = (e) => {
    if (props.isAutoSelect) {
      return e.target.select();
    }
  };

  return (
    <Form.Item
      name={props.name}
      label={props.label}
      initialValue={props.initialValue}
      rules={[
        {
          required: props.requiredMessage !== null,
          message: props.requiredMessage,
        },
      ]}
      style={props.style}
    >
      <Input
        ref={inputReference}
        onFocus={onFocus}
        defaultValue={props.defaultValue}
        onChange={props.onChange}
        placeholder={props.placeholder}
        addonBefore={props.addonBefore}
        addonAfter={props.addonAfter}
        id={props.id}
        disabled={props.disabled}
        maxLength={props.maxLength}
        showCount={props.showCount}
        status={props.status}
        prefix={props.prefix}
        size={props.size}
        suffix={props.suffix}
        onPressEnter={props.onPressEnter}
      />
    </Form.Item>
  );
}

InputText.defaultProps = {
  requiredMessage: null,
};
